import {useLog} from "@/composables/useLog";
import {getFullstackUrl} from "@/composables/useFullstackUrl";

const FULLSTACK = getFullstackUrl();
const log = useLog({url: import.meta.url});

const TOKEN_TRIES = 10;
const TOKEN_RETRY_MS = 300;
const wait = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

async function getSessionToken() {
  try {
    return await window.Clerk?.session?.getToken() ?? null;
  } catch {
    return null;
  }
}

// a signed-in visitor's token; just after signing in (a page opened on #profile) the session
// has no token for a moment, and the call went out without one: refused, which the browser
// reported as CORS (production, 2026-10-19), so it's waited for, up to 3 s
async function getToken() {
  for (let attempt = 1; attempt < TOKEN_TRIES; attempt += 1) {
    const token = await getSessionToken();
    if (token || !window.Clerk?.user) return token;
    await wait(TOKEN_RETRY_MS);
  }
  return await getSessionToken();
}

// a response's JSON, or the fallback: leaving the page cuts a body being read off (an AbortError,
// "The operation was aborted."), which an unguarded await in a watcher logs as an uncaught error
export async function readJson(response, fallback = {}) {
  try {
    return await response.json();
  } catch {
    return fallback;
  }
}

export async function authFetch(path, options = {}) {
  const token = await getToken();
  const headers = {...(options.headers || {})};
  if (token) headers.Authorization = `Bearer ${token}`;
  try {
    return await fetch(`${FULLSTACK}${path}`, {...options, headers});
  } catch (error) {
    log(`network failure for ${path}: ${error?.message}`);
    return new Response("{}", {status: 503, statusText: "Service Unavailable"});
  }
}
